import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { SuggestContentListByTitleResponse } from "./SuggestContentListByTitleResponse";

export const useCatalogueContentSearchApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const { httpGet } = useAuthorizedFetch();
    const baseUrl = `${appConfigContext.catalogueConfig.apiUrl}/contents`;

    const suggestContentListByTitle = async (title: string): Promise<SuggestContentListByTitleResponse> => {
        return httpGet<SuggestContentListByTitleResponse>(`${baseUrl}/suggest-by-title`, {
            title
        });
    };

    return { suggestContentListByTitle };
};
